import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { Me } from 'service/user'
import { BgmFactor } from 'service/list'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from '../../../../../utils/type'
import classNames from 'classnames'
import { isMobile } from 'react-device-detect'
import { BgmPlayer } from '../voice/BgmPlayer'
import { SelectionModal } from 'components/layout/SelectionModal'
import useTranslation from '../../../../../hooks/useTranslation'

interface BgmDisplayProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  userInfo: Me
  bgmList: BgmFactor[] | []
  translatePlanName?: (planName: string) => string
  bgmRefs: React.MutableRefObject<(HTMLAudioElement | null)[]>
  setBgmPlaying: Dispatch<SetStateAction<boolean[]>>
  bgmPlaying: boolean[]
  handleBgmPlayButtonClick: (status: boolean, index: number) => void
}

export const BgmDisplay = ({
  watch,
  setValue,
  control,
  userInfo,
  bgmList,
  bgmRefs,
  translatePlanName,
  setBgmPlaying,
  bgmPlaying,
  handleBgmPlayButtonClick,
}: PropsWithChildren<BgmDisplayProps>) => {
  const { t } = useTranslation()
  const [isListModalOpen, setListModalOpen] = useState<boolean>(false)
  const findBgmNameById = () => {
    const [bgm] = bgmList.filter((el) => el.id === watch('bgmId'))
    return bgm?.name
  }
  const handleListModalOpen = () => {
    setListModalOpen((prev) => !prev)
  }

  useEffect(() => {
    if (isListModalOpen) {
      document.body.classList.add('overflow-hidden') // Tailwind 유틸리티 클래스 사용
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }, [isListModalOpen])

  return (
    <>
      <div className="bgm  mb-10">
        <div className="flex md:flex-row flex-col md:items-center justify-between">
          <p className="font-bold text-[18px] mb-4 md:mb-0  ">{t('productVideoEditor.testEffect.backgroundMusic')}</p>
          <p className="md:w-[630px] w-full h-[61px] rounded-[10px] bg-[#F6F8FB] px-4 py-5 flex items-center justify-between font-bold">
            <span className="">{findBgmNameById()}</span>
            <button
              className="px-2 py-[6px] bg-[#2E343D] text-[white] rounded-[4px] text-[14px]"
              onClick={handleListModalOpen}
              type="button"
            >
              {t('productVideoEditor.testEffect.select')} {'>'}
            </button>
          </p>
        </div>
      </div>
      <SelectionModal isModal={isListModalOpen}>
        <div
          className={classNames('', {
            'bg-white md:w-[816px] h-auto  shadow-main rounded-t-[20px] px-8 pt-8  pb-44 flex flex-col gap-8 ':
              !isMobile,
            'bg-white w-full   shadow-main   flex flex-col   gap-8 pt-10 px-4  ':
              isMobile,
          })}
        >
          <div className="flex flex-col  gap-4   ">
            <p
              className={classNames('flex items-center', {
                'justify-center': isMobile,
                'justify-between': !isMobile,
              })}
            >
              <span className="font-bold text-[24px] text-left">{t('productVideoEditor.testEffect.backgroundMusic')}</span>
              {/* <button
                  onClick={() => {
                    setListModalOpen((prev) => !prev)
                  }}
                  className=""
                >
                  <img
                    src="assets/img/Icon_x.png"
                    alt="icon_x"
                    height={40}
                    width={40}
                  />
                </button> */}
            </p>
          </div>
          <div className=" ">
            <div className="grid grid-cols-1 md:grid-cols-2  gap-x-[22px] gap-y-2   md:pb-4">
              {bgmList?.map((bgm, index) => {
                return (
                  <>
                    <Controller
                      render={({ field }) => (
                        <>
                          {' '}
                          <BgmPlayer
                            {...field}
                            id={index}
                            checked={watch('bgmId') === bgm.id}
                            onChange={() => setValue('bgmId', bgm.id)}
                            // disabled
                            handleFn={handleBgmPlayButtonClick}
                            label={bgm.name}
                            planName={
                              translatePlanName?.(bgm?.planName) ??
                              'Unknown Plan'
                            }
                            className="text-left w-full"
                            index={index}
                            playing={bgmPlaying}
                            src={bgm.path}
                            bgmPlaying={bgmPlaying}
                            setBgmPlaying={setBgmPlaying}
                            bgmRefs={bgmRefs}
                          />{' '}
                        </>
                      )}
                      name="bgmId"
                      control={control}
                    />
                  </>
                )
              })}
            </div>
            {isMobile && (
              <div className="pt-5 pb-20 w-[335px]">
                <button
                  className="bg-main rounded-full w-full text-white font-bold h-[60px]"
                  onClick={handleListModalOpen}
                  type="button"
                >
                  {t('productVideoEditor.buttons.save')}
                </button>
              </div>
            )}
          </div>
        </div>
        {!isMobile && (
          <div
            className="sticky bottom-0  p-8 shadow-main w-full md:w-[816px] bg-white rounded-b-[20px] 
         before:content-[''] before:absolute before:top-[-10px] before:left-0 
         before:w-full before:h-[10px] before:bg-gradient-to-t before:from-black/10 before:to-transparent "
          >
            <button
              className="bg-main rounded-full w-full text-white font-bold h-[60px] "
              onClick={handleListModalOpen}
              type="button"
            >
              {t('productVideoEditor.buttons.save')}
            </button>
          </div>
        )}
      </SelectionModal>
    </>
  )
}
